import axios from "axios";
import { serverAddress } from "constants";

const axiosInstance = axios.create({
  baseURL: serverAddress,
});

const organizationId = localStorage.getItem("organizationId");

export const AddLead = async (data, token) => {
  try {
    const response = await axiosInstance.post("/lead/create", data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ContentType: `application/json`,
      },
    });

    if (response.status === 200 && !response.data.error) {
      return response.data; // Return the response if there's no error
    } else {
      throw new Error("Error adding lead");
    }
  } catch (error) {
    throw error;
  }
};

export const orderDetails = async (uuid, token) => {
  try {
    const response = await axiosInstance.get(
      `/order/job_order_details/${uuid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ContentType: `application/json`,
        },
      }
    );

    if (response.status === 200 && !response.data.error) {
      return response.data; // Return the response if there's no error
    } else {
      throw new Error("Error fetching leads");
    }
  } catch (error) {
    throw error;
  }
};


export const fetchLeadListApi = async (
  options,
  uuid = null,
  token,
  handledBy ="",
  page = 1,
  limit = 10,
  search = ""
) => {
  const filterStatus = options
    ? Object.keys(options)
        .filter((option) => options[option])
        .join(",")
    : "";
    const filterStatusArray = options
    ? Object.keys(options).filter((option) => options[option])
    : [];


    console.log("show filter status fast", options);
    console.log("Search query in API:", search);
  // Construct the base URL with query parameters
  // Ensure search parameter is properly encoded
  const encodedSearch = encodeURIComponent(search || "");
  let url = `/lead/list?page=${page}&limit=${limit}&filterStatus=${filterStatus}&search=${encodedSearch}&empID=31&handledBy=${handledBy ? handledBy : ""}&organizationId=${organizationId}`; // Add organizationId to the URL

  // Conditionally add handledBy if it has a value (non-null and non-empty)
  
  // If uuid is provided, adjust the URL
  if (uuid) {
    url = `/lead/client/${uuid}?page=${page}&limit=${limit}&filterStatus=${filterStatus}&search=${encodedSearch}&handledBy=${handledBy ? handledBy : ""}&organizationId=${organizationId}`;

    try {
      // Send the get request with query parameters in the URL
      const response = await axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || "Error fetching client list:"
      );
    }
  }

  try {
    // Send the POST request with query parameters in the URL
    const response = await axiosInstance.post(url, filterStatusArray, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error in fetchLeadListApi:", error);
    // Handle case where error.response might be undefined
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Error fetching lead list. Please try again.");
    }
  }
};

export const fetchLeadDetails = async (id, token) => {
  try {
    const response = await axiosInstance.get(`/sale/lead/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        ContentType: `application/json`,
      },
    });

    if (response.status === 200 && !response.data.error) {
      return response.data; // Return the response if there's no error
    } else {
      throw new Error("Error fetching lead details");
    }
  } catch (error) {
    throw error;
  }
};

export default axiosInstance;
